const hoverColor = "#116285";
const activeColor = "#0E506D";
const popoverTriggerColor = "#15749D";

export const fallbackValues = {
  hoverColor,
  activeColor,
  popoverTriggerColor
};
